import { usePhotoGalleryStore } from 'stores/usePhotoGalleryStore';
import { css } from 'styled-components';

import Loader from 'components/ui/loading/Loader';
import { ElementTestId } from 'enums/testing';

import { OverlayContainer } from './PhotoPreviewsLoadingOverlay.styles';

const PhotoPreviewsLoadingOverlay = () => {
  const closeGallery = usePhotoGalleryStore(state => state.closeGallery);
  const isOpen = usePhotoGalleryStore(state => state.isOpen);

  if (!isOpen) {
    return null;
  }

  return (
    <OverlayContainer data-testid={ElementTestId.PHOTO_PREVIEWS_LOADING_OVERLAY} onClick={closeGallery}>
      <Loader
        css={css`
          background: transparent;
        `}
      />
    </OverlayContainer>
  );
};

export default PhotoPreviewsLoadingOverlay;
